<template>
  <div
    v-bind:style="showModalTrucks ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Camiones no disponibles</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-form>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>Camiones seleccionados</label>
              </b-col>
              <b-col sm="12">
                <v-select
                  placeholder="Seleccionar camiones"
                  multiple
                  v-model="notAvalible"
                  label="plate"
                  :options="trucks"
                  :on-change="setTrucks"
                ></v-select>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer">
          <button @click="saveAppointment()" type="button" class="btn btn-primary">Guardar</button>
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  name: "ModalTrucks",
  props: ["showModalTrucks", "trucks", "updateTrucks"],
  components: {},
  data() {
    return {
      notAvalible: []
    };
  },
  mounted() {
    this.notAvalible = this.trucks.filter(tr => !tr.portage_active);
  },
  watch: {
    trucks: function(newVal, oldVal) {
      this.notAvalible = newVal.filter(tr => !tr.portage_active);
    }
  },
  methods: {
    saveAppointment() {
      const { makeAssignment, notAvalible } = this;
      const data = { truck_ids: notAvalible.map(na => na.id) };
      this.updateTrucks(data);
      this.close();
    },
    setTrucks(obj) {
      this.notAvalible = obj ? obj : [];
    },
    close() {
      this.selectedTrucks = [];
      this.$emit("close");
    }
  }
};
</script>
